import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import request from "../../../Helpers/API";
import {
  Autocomplete,
  Button,
  TextField,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { GetKey, GetText } from "../../../Helpers/GetKey";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { Moneda } from "../../../Helpers/Moneda";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FeaturedPlayList } from "@mui/icons-material";
import PercentIcon from '@mui/icons-material/Percent';
import { useSelector } from "react-redux";

export const Context = createContext();
const ConvenioPagoScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const { adr, empleado } = useSelector((store) => store.usuario);
  const [showDetallesConvenio, setShowDetallesConvenio] = useState(false);
  const [clientes, setClientes] = useState([]);
  const [tipo, setTipo] = useState("");
  const [convenioPago, setConvenioPago] = useState({
    monto: 0,
    fechaconvenio: "",
    notificacion: false,
    fechanotificacion: "",
    mediocontacto: "LL",
    descuento: 0,
    razon_descuento:"",
    responsable: "",
    idresponsable:0,
    ADR:0,
    firma: "",
    bmonto: false,
  });

  const [responsablesCobranza, setResponsablesCobranza] = useState([]);
  const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([])

  const [sumaFacturas, setSumaFacturas] = useState({
    saldo: 0,
    moratorios: 0,
    pactados:0,
    total: 0
  });

  const [calculoFacturas, setCalculoFacturas] = useState({
    saldo: 0,
    pactados:0,
    moratorios: 0,
    total: 0
  });




  const [info, setInfo] = useState({
    info: {},
    revolvente: {},
    operacion: {},
  });

  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    request
      .get("ConvenioPago/DropDownList")
      .then((result) => {
        setResponsablesCobranza(result);
      })
      .catch((error) => {
        JSON.stringify("PERMISOS", "ERROR....", "error");
      });
  }, []);
  useEffect(() => {
    if (tipo === 'O') {
      setFacturasSeleccionadas([])
      setShowDetallesConvenio(true);
      setLoader({ ...loader, mostrar: true });
      request
        .get(`CPSaldosVencidos/Operacion?idcliente=${state.idcliente}`)
        .then((result) => {
          setClientes(result);
          setLoader({ ...loader, mostrar: false });
          setConvenioPago({
            ...convenioPago,
            monto: 0,
            descuento: 0,
            fechaconvenio: ""
          });
          const checkboxes = document.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
        });
    }
    else if (tipo === 'R') {
      setFacturasSeleccionadas([])
      setShowDetallesConvenio(true);
      setLoader({ ...loader, mostrar: true });
      request
        .get(`CPSaldosVencidos/Revolvente?idcliente=${state.idcliente}`)
        .then((result) => {
          setClientes(result);
          setLoader({ ...loader, mostrar: false });
          setConvenioPago({
            ...convenioPago,
            monto: 0,
            descuento: 0,
            fechaconvenio: ""
          });
          const checkboxes = document.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach((checkbox) => {
            checkbox.checked = false;
          });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
        });
    }
    else {
      setClientes([])
    }
  }, [tipo])
  const agregarConvenioOperacion = () => {
    setFacturasSeleccionadas([])
    setShowDetallesConvenio(true);
    setTipo("O");
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CPSaldosVencidos/Operacion?idcliente=${state.idcliente}`)
      .then((result) => {
        setClientes(result);
        setLoader({ ...loader, mostrar: false });
        setConvenioPago({
          ...convenioPago,
          monto: 0,
          fechaconvenio: ""
        });
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };
  
  const agregarConvenioRevolvente = () => {
    setFacturasSeleccionadas([])
    setShowDetallesConvenio(true);
    setTipo("R");
    setLoader({ ...loader, mostrar: true });
    request
      .get(`CPSaldosVencidos/Revolvente?idcliente=${state.idcliente}`)
      .then((result) => {
        setClientes(result);
        setLoader({ ...loader, mostrar: false });
        setConvenioPago({
          ...convenioPago,
          monto: 0,
          fechaconvenio: ""
        });
        const checkboxes = document.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach((checkbox) => {
          checkbox.checked = false;
        });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };

  const regresar = () => {
    // setShowDetallesConvenio(false);
    // setConvenioPago({
    //   ...convenioPago,
    //   monto: 0,
    //   fechaconvenio: "",
    //   notificacion: false,
    //   fechanotificacion: "",
    //   mediocontacto: "LL",
    // });
    // setClientes([]);
    history.push(
      "/Creditoycobranza/ListadoConvenios",
      {
        idcliente: state.idcliente,
        razonsocial: state.razonsocial
      }
    )
  };

  const handleCheckboxChange = (isChecked, id, documento, fecha, vencimiento, diasvencido, descripcion, importefactura, importepagado, saldo, intereses, interespactado, total) => {
    if (!isChecked) {
      // Eliminar el objeto donde seleccionada es false
      setFacturasSeleccionadas((prevFacturas) =>
        prevFacturas.filter((facturas) => facturas.idfactura !== id)
      );
    } else {
      // Actualizar o agregar el objeto en el array
      const existingPermissionIndex = facturasSeleccionadas.findIndex(
        (facturas) => facturas.idfactura === id
      );

      if (existingPermissionIndex !== -1) {
        setFacturasSeleccionadas((prevFacturas) => [
          ...prevFacturas.slice(0, existingPermissionIndex),
          { ...prevFacturas[existingPermissionIndex], seleccionada: true },
          ...prevFacturas.slice(existingPermissionIndex + 1)
        ]);
      } else {
        setFacturasSeleccionadas((prevFacturas) => [
          ...prevFacturas,
          { idfactura: id, idcliente: state.idcliente, documento, fecha, vencimiento, diasvencido, descripcion, importefactura, importepagado, saldo, intereses, interespactado, total, seleccionada: true },
        ]);
      }
    }
  };

  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setConvenioPago({
      ...convenioPago,
      [prop]: sinComas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  // Calculo de Intereses a Fecha de convenio
  useEffect(() => {
    const interes = facturasSeleccionadas.map(factura => {
      // Parsear las fechas de convenio y vencimiento
      const [anioConvenio, mesConvenio, diaConvenio] = convenioPago.fechaconvenio.split('-');
      const [diaVencimiento, mesVencimiento, anioVencimiento] = factura.vencimiento.split('/');

      // Crear objetos Date utilizando el formato 'yyyy/mm/dd'
      const fechaConvenio = new Date(`${anioConvenio}/${mesConvenio}/${diaConvenio}`);
      const fechaVencimiento = new Date(`${anioVencimiento}/${mesVencimiento}/${diaVencimiento}`);

      // Calcular la diferencia en días
      const diffTime = fechaConvenio - fechaVencimiento;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      // Multiplicar la diferencia en días por el saldo de la factura
      const saldoMultiplicado = (diffDays * factura.saldo * 55.68) / 100 / 360;

      return saldoMultiplicado;
    });
    const subinteres = interes.reduce((total, interes) => total + interes, 0);
    const interesesTotal = (100 - convenioPago.descuento) / 100 * subinteres
    const interesesTotalRedondeado = parseFloat(interesesTotal.toFixed(2));

    const sumaSaldo = facturasSeleccionadas.reduce((total, factura) => total + factura.saldo, 0);

    const total = interesesTotalRedondeado + sumaSaldo
    const totalRedondeado = parseFloat(total.toFixed(2));

    setCalculoFacturas({
      ...calculoFacturas,
      saldo: sumaSaldo,
      moratorios: interesesTotalRedondeado,
      total: totalRedondeado,
    });

  }, [facturasSeleccionadas, convenioPago.fechaconvenio, convenioPago.descuento])
  useEffect(() => {
    const sumaTotal = facturasSeleccionadas.reduce((total, factura) => total + factura.total, 0);
    const sumaMoratorio = facturasSeleccionadas.reduce((total, factura) => total + factura.intereses, 0);
    const sumaPactado = facturasSeleccionadas.reduce((total, factura) => total + factura.interesespactado, 0);
    const sumaSaldo = facturasSeleccionadas.reduce((total, factura) => total + factura.saldo, 0);

    setSumaFacturas({
      ...sumaFacturas,
      saldo: sumaSaldo,
      moratorios: sumaMoratorio,
      pactados: sumaPactado,
      total: sumaTotal,
    });
  }, [facturasSeleccionadas]);

  useEffect(() => {
    if (convenioPago.mediocontacto === "DO") {
      // Resetear el monto a 0 y la fecha de convenio a ""
      setConvenioPago({
        ...convenioPago,
        monto: 0,
        fechaconvenio: ""
      });
    }
  }, [convenioPago.mediocontacto]);

  const imprimirConvenio = () => {
    setLoader({ ...loader, mostrar: true });
    const post = {
      folio: "*************",
      idcliente: state.idcliente,
      razon_social: info.info.razon_social,
      referencia: info.info.referencia,
      adr: convenioPago.ADR,
      monto: convenioPago.monto,
      tipo_credito: tipo,
      fecha_convenio: new Date(),
      recordatorio: convenioPago.notificacion,
      fecha_recordatorio: convenioPago.fechanotificacion,
      mediocontacto: convenioPago.mediocontacto,
      nombre_usuario: convenioPago.responsable.toUpperCase(),
      firma: convenioPago.firma,
      detalle: JSON.stringify(facturasSeleccionadas)
    };
    request
      .post(`ConvenioPago/ReporteConvenioPDF`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        await Swal.fire({
          title: "CONVENIO DE PAGO",
          text: "Impresion",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        history.push("/Creditoycobranza/ConvenioPago");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });

  };
  const guardarConvenio = () => {
    if (facturasSeleccionadas.length === 0) {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Debes seleccionar al menos una factura.",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }
    if (convenioPago.responsable === 0 || convenioPago.responsable === null || convenioPago.responsable === "") {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Selecciona un responsable.",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }
    if (convenioPago.firma === 0 || convenioPago.firma === null || convenioPago.firma === "") {
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "Se necesita el nombre del cliente que firma",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }
    if (convenioPago.mediocontacto === "DO") {
      imprimirConvenio();
      return;
    }

    setLoader({ ...loader, mostrar: true });

    if (convenioPago.monto <= 0 || convenioPago.monto === null || convenioPago.monto === "") {
      setLoader({ ...loader, mostrar: false });
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "El monto a pagar debe de ser mayor a 0",
        icon: "warning",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return; // Detiene la ejecución si no hay facturas seleccionadas
    }

    if (convenioPago.fechanotificacion > convenioPago.fechaconvenio) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire({
        title: "CONVENIO DE PAGO",
        text: "La fecha del recordatorio no debe ser mayor a la fecha de compromiso de pago",
        icon: "error",
        customClass: {
          container: "mi-superpoop",
        },
      });
      return;
    }
    const post = {
      folio: "*************",
      idcliente: state.idcliente,
      razon_social: info.info.razon_social,
      referencia: info.info.referencia,
      adr:convenioPago.ADR,
      monto: convenioPago.monto,
      tipo_credito: tipo,
      fecha_convenio: convenioPago.fechaconvenio,
      recordatorio: convenioPago.notificacion,
      fecha_recordatorio: convenioPago.fechanotificacion,
      mediocontacto: convenioPago.mediocontacto,
      nombre_usuario: convenioPago.responsable.toUpperCase(),
      idresponsable: convenioPago.idresponsable,
      firma: convenioPago.firma,
      descuento:convenioPago.descuento,
      razon_descuento:convenioPago.razon_descuento,
      detalle: JSON.stringify(facturasSeleccionadas)
    };
    request
      .post(`ConvenioPago/Guardar`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        await Swal.fire({
          title: "CONVENIO DE PAGO",
          text: "Registro guardado con éxito",
          icon: "success",
          customClass: {
            container: "mi-superpoop",
          },
        });
        history.push("/Creditoycobranza/ConvenioPago");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };
  const generarConvenio = () => {
    const post = {
      idcliente: state.idcliente,
      razon_social: info.info.razon_social,
      referencia: info.info.referencia,
      mediocontacto: convenioPago.mediocontacto,
      adr,
      tipo_credito: tipo,
    };
    request
      .post(`ConvenioPago/ReporteConvenioPDF`, post)
      .then(async (result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        history.push("/Creditoycobranza/ConvenioPago");
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
      });
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Infoclientes/informacion?idcliente=${Number(state.idcliente)}`)
      .then(({ info, revolvente, operacion }) => {
        setLoader({ ...loader, mostrar: false });
        setInfo({
          info,
          revolvente,
          operacion,
        });
        if (info.tipo_persona === 'F') {
          setConvenioPago({
            ...convenioPago,
            firma: info.razon_social
          })
        }
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CONVENIO PAGO", JSON.stringify(error), "error");
      });
  }, []);
  

  //REPORTE CONVENIO FACTURAS SELECCIONADAS
  return (
    <PlantillaScreen
      titulo={"CONVENIO DE PAGO " + info.info.razon_social}
      className={"convenio-pago-main-screen"}
      className_main={1}
    >
      <LoaderScreen loader={loader} />
      <div className="datos-convenio-pago">
        {/* <div className="datos-convenio-vencidos-clientes">
          <PlantillaScreen
            titulo={"OPERACION"}
            className_main={1}
            className={`convenio-pago-operacion-resumen ${info.operacion.facturas <= 0 && "disabledformulario"
              }`}
          >
            <div
              className="convenio-pago-operacion-resumen-container"
              onClick={() => agregarConvenioOperacion()}
            >
              <div className="convenio-pago-operacion-resumen-container-text">
                <div className="convenio-pago-operacion-datos">IMPORTE:</div>
                <div className="convenio-pago-operacion-datos-cliente">
                  {FormatMoney(info.operacion.saldo)}
                </div>
              </div>
              <div className="convenio-pago-operacion-resumen-container-text">
                <div className="convenio-pago-operacion-datos">
                  INTERESES PACTADO:
                </div>
                <div className="convenio-pago-operacion-datos-cliente">
                  {FormatMoney(info.operacion.interespactado)}
                </div>
              </div>
              <div className="convenio-pago-operacion-resumen-container-text">
                <div className="convenio-pago-operacion-datos">
                  INTERESES MORATORIOS:
                </div>
                <div className="convenio-pago-operacion-datos-cliente">
                  {FormatMoney(info.operacion.intereses)}
                </div>
              </div>
              <div className="convenio-pago-operacion-resumen-container-text">
                <div className="convenio-pago-operacion-datos">TOTAL:</div>
                <div className="convenio-pago-operacion-datos-cliente">
                  {FormatMoney(
                    info.operacion.intereses +
                    info.operacion.interespactado +
                    info.operacion.saldo
                  )}
                </div>
              </div>
              <div className="convenio-pago-operacion-resumen-container-text">
                <div className="convenio-pago-operacion-datos">
                  OPERACIONES:
                </div>
                <div className="convenio-pago-operacion-datos-cliente">
                  {info.operacion.facturas}
                </div>
              </div>
            </div>
          </PlantillaScreen>
          <PlantillaScreen
            titulo={"REVOLVENTE"}
            className_main={1}
            className={`convenio-pago-revolvente-resumen ${info.revolvente.facturas <= 0 && "disabledformulario"
              }`}
          >
            <div
              className="convenio-pago-revolvente-resumen-container"
              onClick={() => agregarConvenioRevolvente()}
            >
              <div className="convenio-pago-revolvente-resumen-container-text">
                <div className="convenio-pago-revolvente-datos">IMPORTE:</div>
                <div className="convenio-pago-revolvente-datos-cliente">
                  {FormatMoney(info.revolvente.saldo)}
                </div>
              </div>
              <div className="convenio-pago-revolvente-resumen-container-text">
                <div className="convenio-pago-revolvente-datos">
                  INTERESES MORATORIOS:
                </div>
                <div className="convenio-pago-revolvente-datos-cliente">
                  {FormatMoney(info.revolvente.intereses)}
                </div>
              </div>
              <div className="convenio-pago-revolvente-resumen-container-text">
                <div className="convenio-pago-revolvente-datos">TOTAL:</div>
                <div className="convenio-pago-revolvente-datos-cliente">
                  {FormatMoney(
                    info.revolvente.saldo + info.revolvente.intereses
                  )}
                </div>
              </div>
              <div className="convenio-pago-revolvente-resumen-container-text">
                <div className="convenio-pago-revolvente-datos">FACTURAS:</div>
                <div className="convenio-pago-revolvente-datos-cliente">
                  {FormatMoney(info.revolvente.facturas, 0)}
                </div>
              </div>
            </div>
          </PlantillaScreen>
        </div> */}

        <div className="convenio-pago-detalle">
          <div className="convenio-pago-detalle-formulario">
            <div className="convenio-pago-agregar-convenio-plantilla">
              <div
                className={`convenio-pago-agregar-convenio`}
              >
                <div className="convenio-pago-agregar-convenio-container scroll-4">
                  <div className="convenio-pago-agregar-convenio-titulo">
                    Crédito{" "}
                    {tipo === "O"
                      ? " POR OPERACION "
                      : tipo === "R"
                        ? " REVOLVENTE"
                        : ""}
                  </div>
                  <TextField
                    className="input-medio-comunicacion"
                    fullWidth
                    size="small"
                    label="Tipo de Crédito"
                    select
                    type="text"
                    onChange={(e) => {
                      setTipo(e.target.value);
                    }}
                  >
                    <MenuItem value={"O"}>OPERACION</MenuItem>
                    <MenuItem value={"R"}>REVOLVENTE</MenuItem>

                  </TextField>
                  <TextField
                    className="input-medio-comunicacion"
                    fullWidth
                    size="small"
                    label="Medio de Contacto"
                    select
                    type="text"
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        mediocontacto: e.target.value,
                      });
                    }}
                    sx={{ mt: 2 }}
                  >
                    <MenuItem value={"LL"}>LLAMADA TELEFONICA</MenuItem>
                    <MenuItem value={"DO"}>VISITA DOMICILIARIA</MenuItem>
                    <MenuItem value={"WH"}>WHATSAPP</MenuItem>

                  </TextField>
                  <TextField
                    id="monto"
                    size="small"
                    label="Monto a Pagar"
                    name="monto"
                    variant="outlined"
                    type="text"
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    disabled={convenioPago.mediocontacto === "DO" ? true : false}
                    onKeyUp={(input) => Moneda(input.target)}
                    // value={convenioPago.monto}
                    // onChange={({ target }) => {
                    //   setConvenioPago({ ...convenioPago, monto: target.value });
                    // }}
                    onChange={({ target }) => {
                      ValOnlyNumber("monto", target.value, onChange, true, 15);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    sx={{ mt: 2 }}
                  />

                  <TextField
                    size="small"
                    type="date"
                    label="Fecha Convenio"
                    value={convenioPago.fechaconvenio}
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        fechaconvenio: e.target.value,
                      });
                    }}
                    sx={{ mt: 2 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    disabled={convenioPago.mediocontacto === "DO" ? true : false}
                  />

                  <TextField
                    id="monto"
                    size="small"
                    label="Descuento"
                    variant="outlined"
                    type="text"
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PercentIcon className="convenio-pago-icono-input-porcentaje" />
                        </InputAdornment>
                      ),
                    }}
                    disabled={convenioPago.mediocontacto === "DO" ? true : false}
                    onKeyUp={(input) => Moneda(input.target)}
                    value={convenioPago.descuento}

                    onChange={({ target }) => {
                      // Validación del descuento máximo
                      const descuento = parseFloat(target.value);
                      if (descuento > 30) {
                        // Mostrar mensaje de alerta
                        Swal.fire({
                          title: "Descuento máximo alcanzado",
                          text: "El máximo descuento permitido es del 30%.",
                          icon: "warning",
                          customClass: {
                            container: "mi-superpoop",
                          },
                        });
                        setConvenioPago({ ...convenioPago, descuento: 0 });
                      } else {
                        setConvenioPago({ ...convenioPago, descuento: descuento });
                      }
                    }}
                    sx={{ mt: 2 }}
                  />

                  <TextField
                    id="outlined-multiline-static"
                    label="Razón de Descuento"
                    disabled={convenioPago.mediocontacto === "DO" ? true : false}
                    multiline
                    rows={1}
                    sx={{ mt: 2 }}

                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        razon_descuento: e.target.value
                      });
                    }}
                  />

                  <TextField
                    className="input-medio-comunicacion"
                    fullWidth
                    size="small"
                    label="Responsable"
                    select
                    type="text"
                    onChange={(e) => {
                      setConvenioPago({
                        ...convenioPago,
                        responsable: e.target.value,
                        ADR: responsablesCobranza.find(cob => cob.responsable_cobranza === e.target.value)?.adr || 0,
                        idresponsable: responsablesCobranza.find(cob => cob.responsable_cobranza === e.target.value)?.idusuario || 0,

                      });
                    }}
                    sx={{ mt: 2 }}
                  >
                    {responsablesCobranza.map((cob) => (
                      <MenuItem value={cob.responsable_cobranza}>{cob.responsable_cobranza}</MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    id="monto"
                    size="small"
                    label="Cliente que Firma"
                    variant="outlined"
                    type="text"
                    inputProps={{
                      style: { textAlign: "right" },
                    }}
                    // disabled={convenioPago.mediocontacto === "DO" ? true : false}
                    value={convenioPago.firma}
                    onChange={({ target }) => {
                      setConvenioPago({ ...convenioPago, firma: target.value.toUpperCase() });
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start"></InputAdornment>
                      ),
                    }}
                    sx={{ mt: 2 }}
                  />

                  {convenioPago.mediocontacto !== "DO" && (
                    <div className="convenio-pago-agregar-datos-columna-2">
                      <div className="convenio-pago-agregar-recordatorio">
                        <span>Recordatorio: </span>
                        <input
                          type="checkbox"
                          name="convenio"
                          className="chk-groups"
                          id="convenio"
                          checked={convenioPago.notificacion}
                          onChange={(e) => {
                            setConvenioPago({
                              ...convenioPago,
                              notificacion: e.target.checked,
                            });
                          }}
                        />
                      </div>
                      {convenioPago.notificacion && (
                        <div>
                          <TextField
                            disabled={!convenioPago.notificacion}
                            size="small"
                            type="date"
                            fullWidth
                            onChange={(e) => {
                              setConvenioPago({
                                ...convenioPago,
                                fechanotificacion: e.target.value,
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                  )}
                  <div className="convenio-pago-calculo-totales">
                    <TextField
                      id="total"
                      size="small"
                      label="Saldo"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "right" },
                        readOnly: true, // Esto deshabilita la edición pero mantiene el estilo normal
                      }}
                      value={FormatMoney(calculoFacturas.saldo)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      id="total"
                      size="small"
                      label="Moratorios"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "right" },
                        readOnly: true, // Esto deshabilita la edición pero mantiene el estilo normal
                      }}
                      value={FormatMoney(calculoFacturas.moratorios)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      id="total"
                      size="small"
                      label="Total"
                      variant="outlined"
                      type="text"
                      inputProps={{
                        style: { textAlign: "right" },
                        readOnly: true, // Esto deshabilita la edición pero mantiene el estilo normal
                      }}
                      value={FormatMoney(calculoFacturas.total)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start"></InputAdornment>
                        ),
                      }}
                      sx={{ mt: 2 }}
                    />
                  </div>

                </div>
                <div className="convenio-pago-buttons">
                  <button
                    className="convenio-pago-button-guardar"
                    onClick={() => guardarConvenio()}
                  >
                    Generar
                  </button>


                </div>
              </div>
              <div className="home-convenio-pago">
                <div
                  className="convenio-pago-button-cancelar"
                  onClick={() => regresar()}
                >
                  {/* <ArrowBackIcon />  */}
                  Regresar
                </div>
              </div>
            </div>
          </div>
          <div className="convenio-pago-listado-clientes-vencidos-container scroll-4">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th>Serie</th>
                  <th>
                    <div>Fecha</div>
                  </th>
                  <th>
                    <div>Vencimiento</div>
                  </th>
                  <th>
                    <div>Dias Vencidos</div>
                  </th>
                  <th>
                    <div>Linea</div>
                  </th>
                  {/* <th>
                    <div>MONTO DE FACTURA</div>
                  </th> */}
                  {/* <th>
                    <div>ABONO</div>
                  </th> */}
                  <th>
                    <div>Saldo</div>
                  </th>
                  {tipo === 'O' ? (
                    <>
                      <th>
                        <div>Moratorios</div>
                      </th>
                      <th>
                        <div>Pactados</div>
                      </th>
                    </>
                  ) : (
                    <th>
                      <div>Moratorios</div>
                    </th>
                  )}

                  <th>
                    <div>Total</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {clientes.map((vc) => (
                  <tr>
                    <td> <input type="checkbox" onChange={(event) => handleCheckboxChange(event.target.checked, vc.id, vc.documento, vc.fecha, vc.vencimiento, vc.diasvencido, vc.descripcion, vc.importefactura, vc.importepagado, vc.saldo, vc.intereses, vc.interespactado, vc.total)}></input></td>
                    <td className="ta-center">{vc.documento}</td>
                    <td className="ta-center">{vc.fecha}</td>
                    <td className="ta-center">{vc.vencimiento}</td>
                    <td className="ta-center">
                      {vc.diasvencido > 0 ? vc.diasvencido : ""}
                    </td>
                    <td>{vc.descripcion}</td>
                    {/* <td>{FormatMoney(vc.importefactura)}</td>
                    <td>{FormatMoney(vc.importepagado)}</td> */}
                    <td className="ta-right">{FormatMoney(vc.saldo)}</td>
                    {tipo === 'O' ? (
                      <>
                        <td className="ta-right">{FormatMoney(vc.intereses)}</td>
                        <td className="ta-right">{FormatMoney(vc.interespactado)}</td>
                      </>
                    ) : (
                      <td className="ta-right">{FormatMoney(vc.intereses)}</td>
                    )
                    }

                    <td className="ta-right">{FormatMoney(vc.total)}</td>
                  </tr>
                ))}
              </tbody>
              {sumaFacturas.total == 0 ? (<div></div>) :
                (
                  <tfoot>
                    <tr>
                      <td className="ta-right"></td>
                      <td className="ta-right"></td>
                      <td className="ta-right"></td>
                      <td className="ta-right"></td>
                      <td className="ta-right"></td>
                      <td className="ta-right">Total:</td>
                      <td className="ta-right">{FormatMoney(sumaFacturas.saldo)}</td>
                      {/* <td className="ta-right">{FormatMoney(sumaFacturas.moratorios)}</td> */}
                      {tipo === 'O' ? (
                      <>
                        <td className="ta-right">{FormatMoney(sumaFacturas.moratorios)}</td>
                        <td className="ta-right">{FormatMoney(sumaFacturas.pactados)}</td>
                      </>
                    ) : (
                      <td className="ta-right">{FormatMoney(sumaFacturas.moratorios)}</td>
                    )
                    }
                      <td className="ta-right">{FormatMoney(sumaFacturas.total)}</td>
                    </tr>
                  </tfoot>
                )}
            </table>
          </div>
        </div>
      </div>
    </PlantillaScreen>
  );
};

export default ConvenioPagoScreen;
